module.exports = __webpack_public_path__ + "img/cbd4blur.247e2e9c.jpg";